import React, { Component } from "react";
import logo from "../../assets/imgs/MyPlay_Logo.svg";
import I18N from "../../I18N";

class Login extends Component {
  emailRef = React.createRef();
  passwordRef = React.createRef();

  render() {
    const { login } = this.props;
    return (
      <div className="login__container">
        <div className="login__container--middle-box">
          <div className="login__container--logo-box">
            <img className="logo-box__logo" src={logo} alt="" />
            <p className="logo-box__text">{I18N.t("SITES_TESTING")}</p>
          </div>
          <input ref={this.emailRef} placeholder="Email" />
          <input
            type={"password"}
            ref={this.passwordRef}
            placeholder="Password"
          />
          <button
              className="login__container__login-button"
            onClick={() => {
              login(
                this.emailRef.current.value,
                this.passwordRef.current.value
              );
            }}
          >
            {I18N.t("LOGIN")}
          </button>
        </div>
      </div>
    );
  }
}
export default Login;
